module.exports = __webpack_public_path__ + "static/joomla-audit-logs-aa9c9ad61a9c4e2d0fe3d586bc1b0e01.png";